import { Component,Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-interval',
  templateUrl: './interval.component.html',
  styleUrls: ['./interval.component.scss']
})
export class IntervalComponent {

  @Input() physicalExamOptions :any;
  @Input() physicalExamOptionsResponse :any;
  @Input() currentCaseDay: number = 1;
  @Input() currentCaseTime: string = '00:00';
  @Input() selectedOrders: any[] = [];
  @Input() linkedOrders: any[] = [];
  @Input() patientInterval: any[] = [];
  @Output() timeAdvance = new EventEmitter<{days: number, hours: number, minutes: number}>();
  
  totalMinutes=0;
  futureTime: string = '';
  // physicalExamOptions = [
  //   'General Appearance',
  //   'Skin',
  //   'Breasts',
  //   'Lymph Nodes',
  //   'HEENT/Neck',
  //   'Chest/Lungs',
  //   'Heart/Cardiovascular',
  //   'Abdomen',
  //   'Genitalia',
  //   'Rectal',
  //   'Extremities/Spine',
  //   'Neuro/Psych'
  // ];

  selectedOptions=[];
  intervalFollowUp: boolean = false;
  showConfirmation=false;
  selectedIds: number[] = [];
  showPhysicalExamination=false;
  showPatientInterval = false;
  patientIntervalDescription = '';
  showIntervalConfirmation = false;
  hasMatchingOrders = false;

  onOkClick(): void {
    
    // Handle OK button click
    // console.log('Selected options:', this.selectedOptions);
    // console.log('Interval/Follow up:', this.intervalFollowUp);
console.log(this.physicalExamOptionsResponse)
    
    if (this.intervalFollowUp) {
      console.log('=== Interval/Follow-up Logic ===');
      console.log('Selected Orders:', this.selectedOrders);
      console.log('Linked Orders:', this.linkedOrders);
      console.log('Patient Intervals:', this.patientInterval);
      console.log('Current Case Day:', this.currentCaseDay);
      console.log('Current Case Time:', this.currentCaseTime);
      
      const drugAndProcedureOrders = this.selectedOrders.filter(order => 
        order.orderType === 3 || order.orderType === 7
      );
      
      console.log('Drug and Procedure Orders (Type 3 & 7):', drugAndProcedureOrders);
      
      const matchingOrders = drugAndProcedureOrders.filter(selectedOrder => 
        this.linkedOrders.some(linkedOrder => linkedOrder.id === selectedOrder.id)
      );
      
      console.log('Matching Orders with LinkedOrders:', matchingOrders);
      
      // Show confirmation popup first (similar to physical examination)
      this.totalMinutes = 2; // Fixed 2 minutes for interval follow-up
      this.calculateFutureTime();
      this.showIntervalConfirmation = true;
      
      // Store the matching orders result for later use
      this.hasMatchingOrders = matchingOrders.length > 0;
      console.log('Has Matching Orders:', this.hasMatchingOrders);
      
      return;
    }

    this.selectedOptions = []
    this.totalMinutes = 0
    //get the details of the selected examinations
    for (let i=0;i<this.selectedIds.length;i++)
    {
      // iterate over the physicalExamOptions and get the details of the selected examinations
      for (let j=0;j<this.physicalExamOptionsResponse.length;j++)
      {
        if (this.physicalExamOptionsResponse[j].evaluationId==this.selectedIds[i])
        {
          this.selectedOptions.push(this.physicalExamOptionsResponse[j])
          this.totalMinutes += parseInt(this.physicalExamOptionsResponse[j].duration)
        }
      }
    }
    console.log(this.selectedOptions)

    // Calculate future time
    this.calculateFutureTime();

    this.showConfirmation=true;
  }

  private findClosestPassedInterval(): any {
    if (!this.patientInterval || this.patientInterval.length === 0) {
      console.log('No patient intervals available');
      return null;
    }
    
    // Filter for positive intervals only (conditionType == 1)
    const positiveIntervals = this.patientInterval.filter(interval => 
      interval.conditionType === 1 || interval.conditionType === '1'
    );
    
    console.log('All patient intervals:', this.patientInterval);
    console.log('Positive intervals (conditionType == 1):', positiveIntervals);
    
    if (positiveIntervals.length === 0) {
      console.log('No positive intervals found');
      return null;
    }
    
    // Parse current time - handle both formats (14:00 and 1400)
    let currentHours, currentMinutes;
    if (this.currentCaseTime.includes(':')) {
      [currentHours, currentMinutes] = this.currentCaseTime.split(':').map(Number);
    } else {
      // Handle 4-digit format like '1400'
      currentHours = parseInt(this.currentCaseTime.substring(0, 2));
      currentMinutes = parseInt(this.currentCaseTime.substring(2, 4));
    }
    
    const currentTotalMinutes = (this.currentCaseDay * 24 * 60) + (currentHours * 60) + currentMinutes;
    
    console.log('Current case day:', this.currentCaseDay);
    console.log('Current case time:', this.currentCaseTime);
    console.log('Parsed current hours:', currentHours, 'minutes:', currentMinutes);
    console.log('Current total minutes:', currentTotalMinutes);
    
    const passedIntervals = positiveIntervals.filter(interval => {
      const intervalDay = parseInt(interval.day) || 1;
      let intervalTime = interval.time || '0000';
      
      // Ensure time is 4 digits
      if (typeof intervalTime === 'number') {
        intervalTime = intervalTime.toString().padStart(4, '0');
      } else if (typeof intervalTime === 'string') {
        intervalTime = intervalTime.replace(':', '').padStart(4, '0');
      }
      
      const intervalHours = parseInt(intervalTime.substring(0, 2));
      const intervalMinutes = parseInt(intervalTime.substring(2, 4));
      const intervalTotalMinutes = (intervalDay * 24 * 60) + (intervalHours * 60) + intervalMinutes;
      
      console.log(`Positive Interval: Day ${intervalDay} @ ${intervalTime} (${intervalHours}:${intervalMinutes}) = ${intervalTotalMinutes} minutes, conditionType: ${interval.conditionType}`);
      console.log(`Passed check: ${intervalTotalMinutes} <= ${currentTotalMinutes} = ${intervalTotalMinutes <= currentTotalMinutes}`);
      console.log(`Description: "${interval.description}"`);
      
      return intervalTotalMinutes <= currentTotalMinutes;
    });
    
    console.log('Passed positive intervals:', passedIntervals);
    
    if (passedIntervals.length === 0) {
      console.log('No passed positive intervals found');
      return null;
    }
    
    const sortedIntervals = passedIntervals.sort((a, b) => {
      const aDay = parseInt(a.day) || 1;
      let aTime = a.time || '0000';
      if (typeof aTime === 'number') {
        aTime = aTime.toString().padStart(4, '0');
      } else if (typeof aTime === 'string') {
        aTime = aTime.replace(':', '').padStart(4, '0');
      }
      const aHours = parseInt(aTime.substring(0, 2));
      const aMinutes = parseInt(aTime.substring(2, 4));
      const aTotalMinutes = (aDay * 24 * 60) + (aHours * 60) + aMinutes;
      
      const bDay = parseInt(b.day) || 1;
      let bTime = b.time || '0000';
      if (typeof bTime === 'number') {
        bTime = bTime.toString().padStart(4, '0');
      } else if (typeof bTime === 'string') {
        bTime = bTime.replace(':', '').padStart(4, '0');
      }
      const bHours = parseInt(bTime.substring(0, 2));
      const bMinutes = parseInt(bTime.substring(2, 4));
      const bTotalMinutes = (bDay * 24 * 60) + (bHours * 60) + bMinutes;
      
      return bTotalMinutes - aTotalMinutes;
    });
    
    console.log('Closest positive interval:', sortedIntervals[0]);
    return sortedIntervals[0];
  }

  calculateFutureTime(): void {
    // Parse current time
    const [currentHours, currentMinutes] = this.currentCaseTime.split(':').map(Number);
    
    // Add total minutes to current time
    let totalMinutesFromStart = (currentHours * 60) + currentMinutes + this.totalMinutes;
    
    // Calculate new day, hours, and minutes
    let newDay = this.currentCaseDay;
    let newHours = Math.floor(totalMinutesFromStart / 60);
    let newMinutes = totalMinutesFromStart % 60;
    
    // Handle day overflow
    while (newHours >= 24) {
      newDay++;
      newHours -= 24;
    }
    
    // Format the future time string
    const formattedHours = newHours.toString().padStart(2, '0');
    const formattedMinutes = newMinutes.toString().padStart(2, '0');
    this.futureTime = `Day ${newDay} @ ${formattedHours}:${formattedMinutes}`;
  }

  selectValue(event)

  {
    console.log(event)
  }

  onClearClick(): void {
    // Clear all selections
    this.selectedIds =[]
    this.intervalFollowUp = false;
  }
  showDetails()
  {
    //show the physical examination here 
    this.showConfirmation=false;
    this.showPhysicalExamination =true;

    // Don't emit time advance here - wait until examination is closed
  }
  

onCheckboxChange(id: number, event: Event): void {
  const isChecked = (event.target as HTMLInputElement).checked;

  if (isChecked) {
    if (!this.selectedIds.includes(id)) {
      this.selectedIds.push(id);
    }
  } else {
    this.selectedIds = this.selectedIds.filter(selectedId => selectedId !== id);
  }
  console.log(this.selectedIds)
}

closeExamination()
{
  this.showPhysicalExamination=false;
  
  // Emit time advance event when examination is closed
  const [futureHours, futureMinutes] = this.futureTime.split('@')[1].trim().split(':').map(Number);
  const futureDay = parseInt(this.futureTime.split('Day')[1].split('@')[0].trim());
  
  this.timeAdvance.emit({
    days: futureDay,
    hours: futureHours,
    minutes: futureMinutes
  });
  
  this.selectedIds=[];
}

closePatientInterval() {
  this.showPatientInterval = false;
  this.intervalFollowUp = false;
  this.patientIntervalDescription = '';
}

showIntervalDetails() {
  // Close the interval confirmation dialog
  this.showIntervalConfirmation = false;
  
  // Determine the interval description based on matching orders
  if (this.hasMatchingOrders) {
    const closestInterval = this.findClosestPassedInterval();
    
    if (closestInterval) {
      console.log('Closest Interval Found:', closestInterval);
      
      // Determine positive or negative interval based on conditionType
      if (closestInterval.conditionType === 1 || closestInterval.conditionType === '1') {
        // Positive interval
        this.patientIntervalDescription = closestInterval.description;
      } else {
        // If conditionType is not 1, treat as negative (fallback)
        this.patientIntervalDescription = this.findNegativeInterval();
      }
    } else {
      // No interval found, show negative interval
      this.patientIntervalDescription = this.findNegativeInterval();
    }
  } else {
    // No matching orders, show negative interval for closest time
    this.patientIntervalDescription = this.findNegativeInterval();
  }
  
  // Show the patient interval popup
  this.showPatientInterval = true;
  
  // Emit time advance event (advance by 2 minutes)
  const [futureHours, futureMinutes] = this.futureTime.split('@')[1].trim().split(':').map(Number);
  const futureDay = parseInt(this.futureTime.split('Day')[1].split('@')[0].trim());
  
  this.timeAdvance.emit({
    days: futureDay,
    hours: futureHours,
    minutes: futureMinutes
  });
}

private findNegativeInterval(): string {
  console.log('&&(()) 327' ,this.patientInterval)
  if (!this.patientInterval || this.patientInterval.length === 0) {
    console.log('No patient intervals available for negative search');
    return 'No patient update present';
  }
  
  // Find intervals with conditionType == 0 (negative intervals) FOR CURRENT DAY ONLY
  // NO TIME CHECK for negative intervals - just day and conditionType
  const negativeIntervalsCurrentDay = this.patientInterval.filter(interval => {
    const intervalDay = parseInt(interval.day) || 1;
    const isNegative = interval.conditionType === 0 || interval.conditionType === '0';
    const isCurrentDay = intervalDay === this.currentCaseDay;
    
    console.log(`Interval: Day ${intervalDay}, ConditionType: ${interval.conditionType}, Current Day: ${this.currentCaseDay}`);
    console.log(`Is Negative: ${isNegative}, Is Current Day: ${isCurrentDay}`);
    console.log(`Description: "${interval.description}"`);
    
    return isNegative && isCurrentDay;
  });
  
  console.log('Looking for negative intervals (conditionType == 0) on current day only - NO TIME CHECK');
  console.log('Current case day:', this.currentCaseDay);
  console.log('Negative intervals found for current day:', negativeIntervalsCurrentDay);
  
  if (negativeIntervalsCurrentDay.length === 0) {
    console.log('No negative intervals found for current day');
    return 'No patient update present';
  }
  
  // Return the first negative interval found for current day (no time check needed)
  console.log('Found negative interval for current day:', negativeIntervalsCurrentDay[0]);
  return negativeIntervalsCurrentDay[0].description;
}
} 